import * as moment from 'moment';

export const disableLastDays = current => current && current < moment(new Date()).add(5, 'days'); // disable last days and add five days from today

export const formatDate = date => {
	return date == null || date === '0001-01-01T00:00:00' ? '-' : date.split('T')[0].split('-').reverse().join('/');
};

export const formatDateTime = dateTime => {
	if(dateTime){
		return dateTime === '0001-01-01T00:00:00' ? '-' : dateTime.toString().split('T')[0].split('-').reverse().join('/').concat(' ').concat(dateTime.toString().split('T')[1].split('.')[0]);
	}
	return null;
};



// WEBPACK FOOTER //
// ./src/util/Date.helper.ts